export const getApiBasePath = (): string => {
  const envUrl = import.meta.env.VITE_API_URL as string | undefined;
  return envUrl || '/api';
};

export const isDev = import.meta.env.DEV;
